import React from "react";
// eslint-disable-next-line no-unused-vars
import {
  ChevronRight,Calendar,Location,UserMultiple,UserFollow,LogoFacebook,LogoTwitter,LogoLinkedin,Link,

} from '@carbon/icons-react';
import useStore from "../../store/useStore";

function highlight(obj:any){
  //    console.log(obj);
    obj.innerHTML="Copied!"
     setTimeout(function(){
          obj.innerHTML= "Copy link";
     }, 2000);
  }

const dummyInput = document.createElement('input')
const  textInput = window.location.href;

function clickToCopy() {
document.body.appendChild(dummyInput);
dummyInput.value = textInput;
dummyInput.select();
document.execCommand('copy');
document.body.removeChild(dummyInput);
}

function clickToShareFB() {

  const titleOfThePage = document.getElementById("TitleOfTheEvent")!.innerHTML;
  const urlOfThePage = location.href;
  const facebookUrl = 'http://www.facebook.com/sharer.php?'+
    'u='+encodeURIComponent(urlOfThePage)+
    '&amp;t='+encodeURIComponent(titleOfThePage);
    return facebookUrl;
  }
  
  function clickToShareTwitter() {
  const titleOfThePage = document.getElementById("TitleOfTheEvent")!.innerHTML;
  const urlOfThePage = location.href;
  const twitterUrl = 'http://twitter.com/share?'+
    'url='+encodeURIComponent(urlOfThePage)+
    '&text='+encodeURIComponent(titleOfThePage);
    console.log(twitterUrl);
    return twitterUrl;
  }
  
  function clickToShareLinkedin() {
  const titleOfThePage = document.getElementById("TitleOfTheEvent")!.innerHTML;
  const urlOfThePage = location.href;
  const linkedinUrl = 'https://www.linkedin.com/shareArticle?mini=true&'+
    'url='+encodeURIComponent(urlOfThePage)+
    '&title='+encodeURIComponent(titleOfThePage);
  window.open(linkedinUrl);
  }

  
  


const BannerEventSessions  = () => {

  const {
    
    settings: {
      params,
    },
    changeViewMySessions,
    setParams,
    
    //filters: { SectorSession },
  } = useStore((state: any) => ({
    
    settings: state.settings,
    changeViewMySessions:state.changeViewMySessions,
    setParams: state.setParams,

  }));

  
  const navigateEvents = () => {
    /*console.log("Navigate to events ");
    // navigate("/");
    setParams('type', 'events')
    setParams('activeRoute', 'events')
    setParams('eventid', '')
*/

location.reload()


  };

  function openMySessions(){
    location.reload()
    /*changeViewMySessions('1')

       //reload my sessionsdata
       const getData = async () => {
       
         // await GetMySessions(); //call geteventsessions if eventid is available
  
      };

      getData();*/

  }
  
  return (
    <>
    <div className="ituContainer grid">
    <div data-span={12}>
    <a onClick={() => navigateEvents()} href='#' className="breadCrumbParent">Event</a> <ChevronRight />  {params.eventName}
    </div>

    <div className="ituCardHero" data-span={12}>
      <h1 className="h2 EventTitle" id="TitleOfTheEvent">
      {params.eventName}
      </h1>
      <div className="ITUEventInfo">
        <div className="ITUEventInfoItem ITUEventLinks">
        <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        className="ITUEventIcon"
        id="ITUEventIcon"
      >
        <Calendar />
          <p style={{ marginBottom: 0, fontSize: "1.25rem" }}>
          {params.eventDateStartEnd}
          </p>
        </div> 
        
      
        
        </div>
        <div className="ITUEventInfoItem">
        <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        className="ITUEventIcon"
        id="ITUEventIcon"
      >
        <Location />
          <p style={{ marginBottom: 0, fontSize: "1.25rem" }}> {params.eventPlace} </p>
          </div></div>
      <div className="ITUEventInfoItem ITUEventLinks">
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        className="ITUEventIcon"
        id="ITUEventIcon"
      >
        <UserMultiple />

<p style={{ marginBottom: 0, fontSize: "1.25rem" }}>{params.eventGroup} - {params.eventSector}</p>
        </div>
        
        <ul className="ITUShareList">
          <li className="ITUShareListItem">
            <a
              className="ITUShareListItemLink"
              id="fbShare"
              target="_blank"
              rel="noopener"
            >
              <LogoFacebook />
            </a>
            <span className="tooltiptext">Share on Facebook</span>
          </li>
          <li className="ITUShareListItem">
            <a
              className="ITUShareListItemLink"
              id="twitterShare"
              target="_blank"
              rel="noopener"
            >
<LogoTwitter />
            </a>
            <span className="tooltiptext">Share on Twitter</span>
          </li>
          <li className="ITUShareListItem"  onClick={() => clickToShareLinkedin()}>
            <a
              className="ITUShareListItemLink"
              id="linkedinShare"
              target="_blank"
              rel="noopener"
            >
<LogoLinkedin />
            </a>
            <span className="tooltiptext">Share on Linkedin</span>
          </li>
          <li
            className="ITUShareListItem"
            onClick={() => highlight(document.getElementById('tooltiptextCopy'))}
          >
            <a className="ITUShareListItemLink" onClick={() => clickToCopy()}>
            <Link />            </a>
            <span className="tooltiptextCopy" id="tooltiptextCopy">
              Copy link
            </span>
          </li>
        </ul>
      </div>
      </div>
      
    </div>
  </div>
  </>
    
    );
}

export default BannerEventSessions;